import React from "react";
import './PrinterSoftware.css';
import { FaCheck, FaArrowRight } from 'react-icons/fa';

const PrinterSoftware = () => {
  const printerBrands = [
    { 
      category: "Laser Printers",
      badge: "High-Volume",
      description: "High-performance laser printers designed to handle massive volumes with minimal maintenance intervals.",
      details: "iMatrix partners with HP to supply commercial laser setups known for speed, high-capacity trays, and crisp business output.",
      image: "/printer/4.webp",
      specs: ["Up to 38 ppm Speed", "Automatic Duplexing", "1200 x 1200 dpi Output", "Network Ready TCP/IP"]
    },
    { 
      category: "Inkjet Printers",
      badge: "Pro Color",
      description: "Exceptional inkjet units engineered for ultra-sharp photo rendering and vibrant corporate brochures.",
      details: "Canon's fine printhead technology guarantees flawless color reproduction, making it optimal for active design departments.",
      image: "/printer/3.jpg",
      specs: ["High Chroma Ink System", "High-Resolution Output", "Borderless Photo Prints", "Direct Card Reader Slot"]
    },
    { 
      category: "All-in-One Printers",
      badge: "Multi-Tasker",
      description: "Multifunction commercial centers carrying printing, heavy flatbed scanning, and rapid copying.",
      details: "Epson EcoTank models deliver extremely low operating costs, high-speed Automatic Document Feeders, and easy refilling.",
      image: "/printer/2.jpg",
      specs: ["Print, Scan, Copy & Fax", "50-Sheet Auto Feeder", "Extremely Low Cost/Page", "Epson Smart Panel App"]
    },
    { 
      category: "Wireless Printers",
      badge: "Smart Mobile",
      description: "Seamless wireless hardware enabling direct print queues from employee laptops, tablets, and smartphones.",
      details: "Brother smart printing protocols provide bulletproof Wi-Fi Direct and easy cloud printing setups for hybrid workspaces.",
      image: "/printer/1.webp",
      specs: ["Secure Wi-Fi Direct Setup", "AirPrint & Mopria Support", "Quiet Mode Engineering", "Direct Cloud Queue Sync"]
    },
  ];

  const featureComparison = [
    { feature: "Print Speed", laser: "Fast (Up to 38 ppm)", inkjet: "Moderate (15 ppm)", allInOne: "Variable (15-30 ppm)", wireless: "Variable (12-24 ppm)" },
    { feature: "Color Quality", laser: "Good (Standard Text)", inkjet: "Excellent (Photo Grade)", allInOne: "Good (Commercial)", wireless: "Good (Standard)" },
    { feature: "Primary Duty", laser: "Bulk Document Printing", inkjet: "Color & Photo Media", allInOne: "Print, Scan & Copy", wireless: "Mobile / Cable-Free" },
    { feature: "Connectivity", laser: "Ethernet & USB Port", inkjet: "Wi-Fi & Standard USB", allInOne: "Wi-Fi, Ethernet & USB", wireless: "Secure Wi-Fi Direct" },
  ];

  return (
    <div className="printer">
      <div className="section-header-left">
        <span className="sub-title">PREMIUM HARDWARE</span>
        <h2 className="printer-title">Integrated Print Fleets</h2>
        <p className="printer-desc-top">
          We provision elite commercial printers and multifunction hubs, complete with genuine cartridges and complete network driver setup.
        </p>
      </div>

      <div className="printer-container">
        {printerBrands.map((printer, index) => (
          <div key={index} className="printer-card-modern">
            <div className="printer-badge-wrap">
              <span className="printer-badge">{printer.badge}</span>
            </div>

            <div className="printer-image-wrapper">
              <img 
                src={printer.image} 
                alt={printer.category} 
                className="printer-image" 
              />
            </div>
            
            <div className="printer-card-body">
              <h3 className="printer-category-name">{printer.category}</h3>
              <p className="printer-desc-main">{printer.description}</p>
              
              <div className="printer-divider"></div>

              <ul className="printer-specs-checklist">
                {printer.specs.map((spec, i) => (
                  <li key={i}>
                    <FaCheck className="printer-tick" />
                    <span>{spec}</span>
                  </li>
                ))}
              </ul>
              
              <p className="details">{printer.details}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="comparison-section">
        <h3 className="comparison-title">Hardware Capability Matrix</h3>
        <div className="table-wrapper">
          <table className="feature-comparison">
            <thead>
              <tr>
                <th>System Feature</th>
                <th>Laser Systems</th>
                <th>Inkjet Systems</th>
                <th>All-in-One Hubs</th>
                <th>Wireless Nodes</th>
              </tr>
            </thead>
            <tbody>
              {featureComparison.map((row, index) => (
                <tr key={index}>
                  <td className="feature-cell" data-label="Feature">{row.feature}</td>
                  <td data-label="Laser">{row.laser}</td>
                  <td data-label="Inkjet">{row.inkjet}</td>
                  <td data-label="All-in-One">{row.allInOne}</td>
                  <td data-label="Wireless">{row.wireless}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PrinterSoftware;
